import { render, staticRenderFns } from "./LahanUmumMonitoringPopulatePertamaAssignmentForm.vue?vue&type=template&id=06977d10"
import script from "./LahanUmumMonitoringPopulatePertamaAssignmentForm.vue?vue&type=script&lang=js"
export * from "./LahanUmumMonitoringPopulatePertamaAssignmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports